<ng-container *transloco="let t">
    @if (roleName == internal) {
    <div class="row">
        <div class="col-md-4 col-sm-6">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    {{t('company')}}
                </label>
                <mat-form-field>
                    <mat-label>
                        {{t('select-company')}}
                    </mat-label>
                    <mat-select [(value)]="selectedCompany" (selectionChange)="changeCompany()">
                        <mat-option *ngFor="let company of companies" [value]="company.id">
                            {{company.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
    <div class="row">
        <!-- Selector de Reportes -->
        <div class="card fade-in">
            <div class="card-header">
                <h2 class="card-title">
                    <span>🏢</span>
                    Seleccionar Tipo de Reporte
                </h2>
                <p class="card-description">
                    Elija el tipo de reporte que desea generar y visualizar
                </p>
            </div>
            <div class="card-content">
                <div class="report-grid">
                    <div class="report-card" data-report="vulnerabilidades">
                        <div class="report-card-content">
                            <span class="report-icon" style="color: #dc3545;">🛡️</span>
                            <div class="report-info">
                                <h3>Vulnerabilidades por Proyecto</h3>
                                <p>Detalle completo de vulnerabilidades encontradas por proyecto</p>
                            </div>
                        </div>
                    </div>
                    <div class="report-card" data-report="resumen_ejecutivo">
                        <div class="report-card-content">
                            <span class="report-icon" style="color: #0066cc;">👁️</span>
                            <div class="report-info">
                                <h3>Resumen Ejecutivo de Seguridad</h3>
                                <p>Vista general del estado de seguridad por proyecto</p>
                            </div>
                        </div>
                    </div>
                    <div class="report-card" data-report="severidad">
                        <div class="report-card-content">
                            <span class="report-icon" style="color: #fd7e14;">🔍</span>
                            <div class="report-info">
                                <h3>Vulnerabilidades por Severidad</h3>
                                <p>Análisis de vulnerabilidades agrupadas por nivel de severidad</p>
                            </div>
                        </div>
                    </div>
                    <div class="report-card" data-report="tendencias">
                        <div class="report-card-content">
                            <span class="report-icon" style="color: #00C688;">📈</span>
                            <div class="report-info">
                                <h3>Tendencias Temporales</h3>
                                <p>Evolución temporal de vulnerabilidades y métricas</p>
                            </div>
                        </div>
                    </div>
                    <div class="report-card" data-report="cumplimiento">
                        <div class="report-card-content">
                            <span class="report-icon" style="color: #6f42c1;">✅</span>
                            <div class="report-info">
                                <h3>Cumplimiento y SLA</h3>
                                <p>Seguimiento del cumplimiento de SLA y tiempos de resolución</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="controls">
                    <div class="select-wrapper">
                        <mat-select [(value)]="selectedReport">
                            <mat-option value="">Seleccione un tipo de reporte...</mat-option>
                            <mat-option value="vulnerabilidades">Vulnerabilidades por Proyecto</mat-option>
                            <mat-option value="resumen_ejecutivo" disabled>Resumen Ejecutivo de Seguridad</mat-option>
                            <mat-option value="severidad" disabled>Vulnerabilidades por Severidad</mat-option>
                            <mat-option value="tendencias" disabled>Tendencias Temporales</mat-option>
                            <mat-option value="cumplimiento" disabled>Cumplimiento y SLA</mat-option>
                        </mat-select>
                    </div>
                    @if(selectedReport) {
                    <div id="downloadButtons" style="display: flex;">
                        <button mat-button class="btn button-primary" id="pdfBtn" (click)="downloadPdf()">
                            📄 PDF
                        </button>
                        <button mat-button class="btn button-accent" id="excelBtn" (click)="downloadExcel()">
                            📊 Excel
                        </button>
                    </div>
                    }
                </div>

                <div id="successMessage" class="success-message">
                    <strong>✅ Descarga exitosa:</strong> <span id="successText"></span>
                </div>
            </div>
        </div>
        <!-- Estado Vacío -->
         @if(!selectedReport) {
        <div id="emptyState" class="card fade-in">
            <div class="card-content">
                <div class="empty-state">
                    <div class="empty-icon"></div>
                    <h3 style="font-family: var(--font-heading); color: var(--altair-primary); margin-bottom: 0.5rem;">
                        Bienvenido al Módulo de Reportes
                    </h3>
                    <p style="max-width: 400px; margin: 0 auto;">
                        Seleccione un tipo de reporte para comenzar a visualizar los datos de vulnerabilidades
                        y generar informes detallados en formato PDF o Excel.
                    </p>
                </div>
            </div>
        </div>
        }
    </div>
</ng-container>
